import axios from 'axios'

export interface TGetUserIPResponse {
  ip: string
}

export const getUserIP = () =>
  axios.get<TGetUserIPResponse>('https://api.ipify.org?format=json')
